module.exports = __webpack_public_path__ + "img/qr-code-btn.95cac783.svg";